import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { BaseButton } from '@bnnvara/buttons';
import { FilterSelect } from '@bnnvara/forms/src/components/Select/FilterSelect/FilterSelect';
import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { FetchMediaList } from '../../api/queries/media.gql';
import BaseVideoCard from '../cards/VideoCard';
import Link, { useLink } from '../Link';
import Paginator from '../Paginator';
import {
  getPeriod,
  getType,
  periodOptions,
  typeOptions,
} from './mediaOverviewFilterOptions';
import * as S from './styled';

const MediaCard = React.forwardRef((props, forwardedRef) => {
  const { id, mediaType, index } = props;
  const mediaLink = mediaType === 'video' ? 'videos' : 'audio';

  return (
    <GridItem
      ref={forwardedRef}
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 6"
      columnEndXl="span 3"
    >
      <Link
        href={`/${mediaLink}/${id}`}
        action="click"
        category="videooverzicht"
        label={`video-${index}`}
      >
        <BaseVideoCard {...props} />
      </Link>
    </GridItem>
  );
});

MediaCard.defaultProps = {
  id: null,
  mediaType: 'video',
};

MediaCard.propTypes = {
  id: PropTypes.string,
  mediaType: PropTypes.string,
  index: PropTypes.number.isRequired,
};

const MediaOverview = ({ limit }) => {
  const { query } = useRouter();
  const { slug: brandSlug } = useBrand();
  const { setQueryParams } = useLink();

  const currentType = getType(query.type || 'alles');
  const currentPeriod = getPeriod(query.since || 'alles');

  const loadMoreButton = (
    <BaseButton variant="underline">
      <span
        onClick={() => {
          track('videooverzicht', 'click', 'toon-meer-videos');
        }}
        onKeyDown={() => {
          track('videooverzicht', 'click', 'toon-meer-videos');
        }}
        role="button"
        tabIndex={0}
      >
        Toon meer media
      </span>
    </BaseButton>
  );

  return (
    <Fragment>
      <GridItem
        columnStartSm="1"
        columnEndSm="span 12"
        columnStartMd="1"
        columnEndMd="13"
      >
        <S.GridFilter>
          <Heading element="h1" variant="brand">
            Media
          </Heading>
          <S.FilterSelectGroup>
            <FilterSelect
              onChange={(event) => setQueryParams({ type: event.target.value })}
              value={query.type}
              text="Type"
            >
              {typeOptions.map(({ label, slug }) => (
                <option value={slug} key={label}>
                  {label}
                </option>
              ))}
            </FilterSelect>
            <FilterSelect
              onChange={(event) =>
                setQueryParams({ since: event.target.value })
              }
              value={query.since}
              text="Periode"
            >
              {periodOptions.map(({ label, slug }) => (
                <option value={slug} key={label}>
                  {label}
                </option>
              ))}
            </FilterSelect>
          </S.FilterSelectGroup>
        </S.GridFilter>
      </GridItem>
      <Paginator
        limit={limit}
        ItemComponent={MediaCard}
        query={FetchMediaList}
        variables={{
          brandSlug,
          type: currentType.option,
          since: currentPeriod.option,
        }}
        itemsKey="brand.mediaList"
        loadMoreElement={loadMoreButton}
      />
    </Fragment>
  );
};

MediaOverview.defaultProps = {
  limit: 8,
};

MediaOverview.propTypes = {
  limit: PropTypes.number,
};

export default MediaOverview;
